<template>
    <rkm-area
        no-margin-top
        title="Compartilhamento de cuidado"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.compartilhamentosCuidado"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.especialidade.nome"
                                    label="Especialidade"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => item.usuario.nome"
                                    label="Profissional"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-area
                                    no-margin-top
                                    title="Problemas e/ou condições"
                                >
                                    <rkm-row>
                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => `${item.ciap.codigo} - ${item.ciap.descricao}`"
                                                label="CIAP 2"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="6">
                                            <Item
                                                :get-value="() => `${formatCid(item.cid.codigo)} - ${item.cid.nome}`"
                                                label="CID 10"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-area
                                    no-margin-top
                                    title="Classificação de risco / vulnerabilidade"
                                >
                                    <rkm-row>
                                        <rkm-col cols="12">
                                            <Item :get-value="() => item.classificacaoRisco.nome" />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row class="mt-3">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.discussaoCasoClinico"
                                    label="Discussão de caso clínico"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>